import { RefObject } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';

/**
 * PrimeReact drops an OverlayPanel below its trigger, which inside the side nav
 * means covering the category names. These two move it beside the nav instead,
 * level with the filter it belongs to.
 *
 * It takes two steps because onShow only runs once the enter transition has
 * finished: by then the panel has already been on screen in the wrong place.
 * So hide it as it enters, and reveal it again once it has been placed.
 */
export const hidePanelUntilPlaced = (overlay: RefObject<OverlayPanel>): void => {
  const panel = overlay.current?.getElement();
  if (panel) panel.style.visibility = 'hidden';
};

export const openPanelBesideNav = (overlay: RefObject<OverlayPanel>, triggerId: string): void => {
  const panel = overlay.current?.getElement();
  if (!panel) return;

  try {
    const trigger = panel.ownerDocument.getElementById(triggerId);
    const nav = panel.ownerDocument.querySelector('.nc_side-nav');
    if (!trigger || !nav) return;

    panel.style.position = 'fixed';
    panel.style.left = `${nav.getBoundingClientRect().right + 8}px`;
    panel.style.top = `${trigger.getBoundingClientRect().top}px`;
  } finally {
    // Always restore it: a panel left hidden would be unusable.
    panel.style.visibility = 'visible';
  }
};
